import ResultImage from 'components/ui/Results/ResultImage';
import { ResultItemProps } from 'components/ui/Results/ResultItem';
// #region Tapecase
import React, { useContext, useEffect, useState } from 'react';
// #endregion
import { useHawkSearch } from 'shared/components/hawksearch/components/StoreProvider';
// #region Tapecase
import VisuallyHiddenAnnouncementContext from 'shared/components/VisuallyHiddenAnnouncementContext';
// #endregion
import { dispatchRocEvent } from 'shared/hooks/useRocEventHandler';
// #region Tapecase
// import { DisplayPrice } from 'shared-client/types/commerce/display-price';
// import ProductPricing from 'shared/components/commerce/ProductPricing';
// #endregion

function ProductResultItem({ item, testId }: ResultItemProps) {
	// #region Tapecase
	const { setAlert } = useContext(VisuallyHiddenAnnouncementContext);
	// #endregion

	const [compareCheck, setCompareCheck] = useState(false);
	const {
		store: { itemsToCompareIds },
		actor,
	} = useHawkSearch();
	useEffect(() => {
		setCompareCheck(itemsToCompareIds.indexOf(item.DocId) !== -1 ? true : false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [itemsToCompareIds]);

	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');

	// unique_id is required for HawkSearch tracking
	const uniqueId = item.getDocumentValue('unique_id');

	//#region: TapeCase
	const leadTime = item.getDocumentValue('productattr_leadtime');
	const plpDescription = item.getDocumentValue('productattr_plpdescription');
	//#endregion

	// function for dispatching product-clicked event
	// this is handled by hawksearch-commerce-tracker to report click event to Hawk Tracking API
	const dispatchProductClickEvent = () => {
		if (uniqueId) {
			dispatchRocEvent('product-clicked', {
				productId: uniqueId,
				url: url || '',
				productName: itemName || '',
				productGroupId: null,
			});
		}
	};

	function toggleItemsToCompare() {
		if (itemsToCompareIds.length >= 5 && compareCheck === false) {
			alert('You can compare up to 5 items');
			return;
		}
		actor.setItemsToCompare(item, !compareCheck);

		// #region Tapecase
		if (!compareCheck) {
			// Adding

			if (itemsToCompareIds.length === 0) {
				// First item added
				setAlert(
					`Now comparing ${
						itemsToCompareIds.length + 1
					} item. The comparison area is at the end of the products results.`,
				);
			} else {
				setAlert(
					`Now comparing ${
						itemsToCompareIds.length + 1
					} items. The comparison area is at the end of the products results.`,
				);
			}
		} else {
			// Removing

			if (itemsToCompareIds.length === 1) {
				// Removing last item
				setAlert(`Now comparing ${itemsToCompareIds.length - 1} items.`);
			} else if (itemsToCompareIds.length === 2) {
				// Removing 2nd to last item
				setAlert(
					`Now comparing ${
						itemsToCompareIds.length - 1
					} item. The comparison area is at the end of the products results.`,
				);
			} else {
				setAlert(
					`Now comparing ${
						itemsToCompareIds.length - 1
					} items. The comparison area is at the end of the products results.`,
				);
			}
		}
		// #endregion
	}

	return (
		<div className="hawk-results__item">
			<ResultImage item={item} onClick={dispatchProductClickEvent} />

			<div className="hawk-results__item-name" data-testid={`hawk-result-${testId}`}>
				{url ? (
					<a className="hawk-results__item-name-link" href={url} onClick={() => dispatchProductClickEvent()}>
						<span>{itemName}</span>
					</a>
				) : (
					<span>{itemName}</span>
				)}
			</div>

			{/* #region Tapecase */}
			{/* <ProductPriceRenderer item={item} testId={testId} /> */}
			<p>{plpDescription}</p>
			{/* #endregion */}
			{leadTime ? <p>Lead Time : {leadTime} </p> : null}
			<div className="hawk-compare">
				<label className="hawk-compare__label" htmlFor={uniqueId}>
					<input
						className="hawk-compare__checkbox"
						id={uniqueId}
						type="checkbox"
						checked={compareCheck}
						onChange={() => toggleItemsToCompare()}
					/>
					<span className="hawk-compare__text">Compare</span>
				</label>
			</div>
		</div>
	);
}

//#region TapeCase
// function ProductPriceRenderer({ item, testId }: ResultItemProps) {
// 	// fields for group pricing
// 	const displayPriceStringified =
// 		item.getDocumentValue('product_groupdisplayprice') || item.getDocumentValue('product_displayprice');

// 	const displayPrice = displayPriceStringified ? (JSON.parse(displayPriceStringified) as DisplayPrice) : undefined;

// 	return (
// 		<ProductPricing
// 			className="hawk-results__item-price"
// 			displayPrice={displayPrice}
// 			testId={`hawk-result-pricing-${testId}`}
// 		/>
// 	);
// }
//#endregion

export default ProductResultItem;
